
import React from "react";
import { Row, Col, Card } from '@themesberg/react-bootstrap';

const Footer = () => {
  return (
    <div>
      <footer className="footer section py-5">
        <Row>
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <p className="mb-0 text-center text-xl-left">
              Copyright © 2025
              <Card.Link href="javascript:void(0)" className="text-blue text-decoration-none fw-normal">
                Admin Panel
              </Card.Link>
            </p>
          </Col>
        </Row>
      </footer>
    </div>
  );
};

export default Footer;
